<template>
  <div class="bgSet">
    <!-- top -->
    <div class="bgSetting-top">
      <div class="bgSetting-top-title">
        <span>后台设置</span>
        <!-- 提示帮助图标 -->
        <div class="attention">
          <div class="attention-model">
            <i></i>
            <ul>
              <li>
                <p>登录帐号默认后台权限为企业趋势和企业统计
                </p>
              </li>
              <li>
                <p> 帐号登录后将根据其拥有的权限显示对应的导航栏和界面
                </p>
              </li>

            </ul>
          </div>
        </div>
      </div>

    </div>

    <div class="crmAccountActions">
      <strong>CRM账号管理</strong>
      <div class="crmAccountActions-buttons">
        <el-button size="small" type="primary" icon="plus" @click="openCrmDialog('register')">注册CRM账号</el-button>
        <el-button size="small" icon="edit" @click="openCrmDialog('password')">重置CRM密码</el-button>
        <el-button size="small" icon="setting" @click="openCrmDialog('token')">重置M令牌</el-button>
      </div>
    </div>

    <!-- bottom -->
    <div class="bgSetting-bottom">
      <!-- 表单 -->
      <div class="bgSetting-form">
        <el-form ref="bgSearchFormDatas" :model="bgSearchFormDatas">
          <div class="loginAccount">
            <label>
              登录账号
              <el-input size="small" placeholder="请输入内容" v-model="bgSearchFormDatas.loginAccountVal">
              </el-input>
            </label>
          </div>
          <!-- 后台权限 -->
            <div class="bgJurisdiction">
            <div class="defaultJurisdiction">后台权限:
              <span>企业趋势</span>
              <span>企业统计</span>
            </div>

            <el-checkbox-group v-model="bgSearchFormDatas.bgJurisdictionVal">
              <el-checkbox label="企业订单" name="bgJurisdictionVal"></el-checkbox>
              <el-checkbox label="企业管理" name="bgJurisdictionVal"></el-checkbox>
              <el-checkbox label="企业观察" name="bgJurisdictionVal"></el-checkbox>
              <el-checkbox label="企业网站" name="bgJurisdictionVal"></el-checkbox>
              <el-checkbox label="系统设置" name="bgJurisdictionVal"></el-checkbox>
              <el-checkbox label="后台设置" name="bgJurisdictionVal"></el-checkbox>
            </el-checkbox-group>
           

            <div class="funcBtn">
              <el-button @click="searchAccount">搜索</el-button>
              <span @click="exportUsersData"></span>
            </div>
          </div>
        </el-form>
      </div>
      <!-- content:list -->
      <div class="bgSetting-content">
        <table>
          <thead>
            <tr>
              <th>登录账号
                <i @click="addAccount"></i>
              </th>
              <th>运营管理后台权限</th>
              <th>最近一次登录时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in currentUsersListData" :key="index">
              <td>{{item.account}}</td>
              <td>
                <span v-for="(privilege,privilegeIndex) in item.privileges" :key="privilegeIndex">{{privilege | filterPageName}}</span>
              </td>
              <td>{{item.last_login}}</td>
              <td>
                <span @click="editAccountBg(item,index)" v-if="item.account != 'admin'">
                  <i class="editBg"></i>
                </span>
                <span @click="delAccountBg(item.id,item.account)" v-if="item.account != 'admin'">
                  <i class="deleteBg"></i>
                </span>
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <!-- 分页器 -->
     <subpagination :paginationCurrentPage="currentPage" :totalToPag="companyTotal" @current-change="getCurrentListData"></subpagination>
    </div>

      <!-- 添加账号弹出框 -->
    <div class="modelShieldLayer"></div>

    <el-dialog title="注册CRM账号" :visible.sync="crmDialogs.register" size="tiny" :close-on-click-modal="false" @close="resetCrmForm('crmRegisterForm')">
      <el-form ref="crmRegisterForm" :model="crmRegisterForm" :rules="crmRegisterRules" label-width="96px">
        <el-form-item label="CRM服务器" prop="server_uid">
          <el-select v-model="crmRegisterForm.server_uid" filterable placeholder="请选择服务器">
            <el-option v-for="server in crmServers" :key="server" :label="server" :value="server"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业名称" prop="company">
          <el-input v-model.trim="crmRegisterForm.company" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="登录邮箱" prop="email">
          <el-input v-model.trim="crmRegisterForm.email" :maxlength="160"></el-input>
        </el-form-item>
        <el-form-item label="初始密码" prop="password">
          <el-input v-model="crmRegisterForm.password" type="password" :maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="注册来源" prop="origin">
          <el-input v-model.trim="crmRegisterForm.origin" :maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="crmDialogs.register = false">取消</el-button>
        <el-button type="primary" :loading="crmSubmitting" @click="submitCrmRegister">注册并激活</el-button>
      </span>
    </el-dialog>

    <el-dialog title="重置CRM密码" :visible.sync="crmDialogs.password" size="tiny" :close-on-click-modal="false" @close="resetCrmForm('crmPasswordForm')">
      <el-form ref="crmPasswordForm" :model="crmPasswordForm" :rules="crmPasswordRules" label-width="96px">
        <el-form-item label="CRM服务器" prop="server_uid">
          <el-select v-model="crmPasswordForm.server_uid" filterable placeholder="请选择服务器">
            <el-option v-for="server in crmServers" :key="server" :label="server" :value="server"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号/邮箱" prop="account">
          <el-input v-model.trim="crmPasswordForm.account" placeholder="请输入CRM账号或登录邮箱" :maxlength="160"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="crmPasswordForm.password" type="password" :maxlength="64"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="crmDialogs.password = false">取消</el-button>
        <el-button type="primary" :loading="crmSubmitting" @click="submitCrmPassword">确认重置</el-button>
      </span>
    </el-dialog>

    <el-dialog title="重置M令牌" :visible.sync="crmDialogs.token" size="tiny" :close-on-click-modal="false" @close="resetCrmForm('crmTokenForm')">
      <el-form ref="crmTokenForm" :model="crmTokenForm" :rules="crmTokenRules" label-width="96px">
        <el-form-item label="CRM服务器" prop="server_uid">
          <el-select v-model="crmTokenForm.server_uid" filterable placeholder="请选择服务器">
            <el-option v-for="server in crmServers" :key="server" :label="server" :value="server"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号/邮箱" prop="account">
          <el-input v-model.trim="crmTokenForm.account" placeholder="请输入CRM账号或登录邮箱" :maxlength="160"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="crmDialogs.token = false">取消</el-button>
        <el-button type="danger" :loading="crmSubmitting" @click="submitCrmToken">关闭M令牌</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style lang='scss' scoped>
@function p2r($size) {
  @return $size/16*1rem;
}



// top部分
.bgSetting-top {
  display: flex;
  justify-content: space-between;
  height: 70px; // top的左边标题
  .bgSetting-top-title {
    padding-left: p2r(18);
    height: 100%;
    position: relative;
    span {
      display: inline-block;
      padding-top: 23px;
      font-size: 18px;
      color: #666;
    }
    .attention {
      position: absolute;
      top: 28px;
      right: -26px;
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../../statics/img/icon@2x.png") no-repeat 0 -729px;
      .attention-model {
        position: absolute;
        width: 400px;
        top: -20px;
        left: 50px;
        z-index: 2;
        background: rgba(0, 0, 0, .8);
        padding: 15px;
        box-sizing: border-box;
        border-radius: 10px;
        display: none;
        i {
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 12px solid transparent;
          border-right: 24px solid rgba(0, 0, 0, .8);
          border-bottom: 12px solid transparent;
          position: absolute;
          left: -24px;
          top: 17px;
        }
        ul {
          list-style-type: disc;
          li {
            p {
              color: #fff;
              padding: 10px;
              font-size: 14px;
            }
          }
        }
      }
      &:hover {
        .attention-model {
          display: block;
        }
      }
    }
  }
}

// bottom部分
.bgSetting-bottom {
  padding-left: 3px;

  
  
  // 表单 
  //后台设置样式
  .bgSetting-form {
    font-size: 14px;
    color: #65657a;
    .loginAccount {
      //登录账号文本框
      .el-input {
        width: 180px;
        padding-left: 10px;
      }
    } // 后台权限
    .bgJurisdiction {
      margin-top: 25px;
      display: flex;
      .defaultJurisdiction {
        padding-right: p2r(25);
        span {
          padding-left: p2r(24);
          color: #999;
        }
      }
      .el-checkbox-group {
        .el-checkbox {
          padding-right: p2r(20);
          color: #999;
          margin: 0;
        }
      }
      .funcBtn {
        padding-left: p2r(90);
        margin-top: -7px;
        button {
          width: 100px;
          height: 30px;
          background: linear-gradient(to bottom, #22A89A, #28B79B);
          color: #f6f6f6;
          font-size: 16px;
          border-radius: 4px;
          border: none;
          box-shadow: 2px 2px 1px #ccc;
          cursor: pointer;
        }
        span {
          display: inline-block;
          width: 26px;
          height: 27px;
          background: url("../../statics/img/icon@2x.png") no-repeat -115px -805px;
          margin-left: p2r(45);
          vertical-align: top;
          margin-top: 3px;
        }
      }
    }
  } // list列表
  .bgSetting-content {
    width: 97%;
    margin-top: 30px;
    table {
      table-layout:fixed;
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #E6E6E6;
      thead {
        border-bottom: 1px solid #E6E6E6;
        tr {
          th {
            height: 39px;
            text-align: center;
            font-size: 14px;
            font-weight: 100;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            &:nth-child(1) {
              width: p2r(212);
              i {
                position: absolute;
                width: 16px;
                height: 16px;
                background: url("../../statics/img/icon@2x.png") no-repeat 0 -956px;
                margin-top: 3.5px;
                margin-left: 9px;
                cursor: pointer;
              }
            }
            &:nth-child(2) {
              width: p2r(550);
            }
            &:nth-child(3) {
              width: p2r(406);
            }
            &:nth-child(4) {}
          }
        }
      }
      tbody {
        tr {
          height: 40px;
          border: 1px solid #E6E6E6;
          &:hover {
            background: #def0f2;
          }
          td {
            overflow: hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            font-size: 13px;
            color: #828282;
            text-align: center;
            &:nth-child(1) {
              width: p2r(212);
              box-sizing: border-box;
            }
            &:nth-child(2) {
              width: p2r(550);
              text-align: center;
              box-sizing: border-box;
              >span {
                padding-left: 8px;
              }
            }
            &:nth-child(3) {
              width: p2r(406);
              box-sizing: border-box;
            }
            &:nth-child(4) {
              >span {
                display: inline-block;
                cursor: pointer;
                padding: 10px 20px;
                i {
                  display: inline-block;
                }
                .editBg {
                  width: 12px;
                  height: 12px;
                  background: url("../../statics/img/icon@2x.png") no-repeat -112px -958px;
                }
                .deleteBg {
                  width: 9px;
                  height: 13px;
                  background: url("../../statics/img/icon@2x.png") no-repeat -196px -957px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.crmAccountActions {
  min-height: 54px;
  padding: 10px 18px;
  border-top: 1px solid #eceff1;
  border-bottom: 1px solid #e1e5e8;
  background: #f8faf9;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  strong {
    color: #4b565b;
    font-size: 15px;
    font-weight: 500;
  }

  .crmAccountActions-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

.crmAccountActions + .bgSetting-bottom {
  margin-top: 0;
}

.el-dialog .el-select {
  width: 100%;
}

.el-dialog--tiny {
  width: 460px;
  max-width: calc(100% - 32px);
}


// }
</style>
<script>
import "../../statics/css/bgSet.scss";
import bus from "../../common/commonVue.js";
import qs from "qs";

// 导入分页子组件
import subpagination from "../subcomponent/subPaginationCom.vue";

export default {
  data() {
    return {
      //搜索栏表单数据
      bgSearchFormDatas:{
        // 文本框value
        loginAccountVal: '',
        //复选框value
        bgJurisdictionVal: []
      },
      // 获取当前用户列表
      currentUsersListData: [

      ],
      // 获取所有用户列表
      allUserListData:[
        {
          account:"",
          last_login:"",
          privileges:[]
        }
      ],
      // 获取所有用户列表
      allUserListData1:[
          {
              account:"",
              last_login:"",
              privileges:[]
          }
      ],
      //导出用户数据地址
      exportUrl:"",
      filterSearchParams: [],
      //列表数据总数
      companyTotal:0,
      page:0,
      currentPage:1,
      crmServers: [],
      crmSubmitting: false,
      crmDialogs: {
        register: false,
        password: false,
        token: false
      },
      crmRegisterForm: {
        server_uid: "",
        company: "",
        email: "",
        password: "",
        origin: "backoffice"
      },
      crmPasswordForm: {
        server_uid: "",
        account: "",
        password: ""
      },
      crmTokenForm: {
        server_uid: "",
        account: ""
      },
      crmRegisterRules: {
        server_uid: [{ required: true, message: "请选择CRM服务器", trigger: "change" }],
        company: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        email: [
          { required: true, message: "请输入登录邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入初始密码", trigger: "blur" },
          { min: 6, message: "密码不能少于6个字符", trigger: "blur" }
        ]
      },
      crmPasswordRules: {
        server_uid: [{ required: true, message: "请选择CRM服务器", trigger: "change" }],
        account: [{ required: true, message: "请输入CRM账号或登录邮箱", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码不能少于6个字符", trigger: "blur" }
        ]
      },
      crmTokenRules: {
        server_uid: [{ required: true, message: "请选择CRM服务器", trigger: "change" }],
        account: [{ required: true, message: "请输入CRM账号或登录邮箱", trigger: "blur" }]
      }
    }
  },
  created() {
    this.getUserList("", []);
    this.getCrmServers();
  },
  mounted() {
    //接收添加账号确定后的数据--渲染列表
    bus.$on("applybgaddlistdata",(data) => {
      //点击搜索按钮，传值分页器，让分页器页数为1
      this.currentPage = 1;

      this.allUserListData.splice(1,0,data);
      console.log("this.page",this.page)
      if(this.page == 0) {
        this.currentUsersListData.splice(1,0,data);
      }
      if(this.currentUsersListData.length % 15 == 1) {
        this.currentUsersListData.pop();
        this.searchAccount();
      }
    });
    // 接收添加帐号后返回所有的帐号列表
    bus.$on("addaccountcallback",() => {
        this.bgSearchFormDatas.loginAccountVal = ""
        this.bgSearchFormDatas.bgJurisdictionVal = []
        this.searchAccount();
    })
    //接收修改账号确定后的数据--渲染列表
    bus.$on("applybgeditlistdata",() => {
      this.searchAccount()
    });
    //接收删除弹出框触发的条件
    bus.$on("resetapplydata",() => {
      this.searchAccount(); 
    })
  },
  methods: {
    getCrmServers() {
      this.$ajax.post("/api/crm_servers").then(res => {
        if (res.data && !res.data.error && Array.isArray(res.data.data)) {
          this.crmServers = res.data.data;

          if (this.crmServers.length === 1) {
            const server = this.crmServers[0];
            this.crmRegisterForm.server_uid = server;
            this.crmPasswordForm.server_uid = server;
            this.crmTokenForm.server_uid = server;
          }
        }
      });
    },
    openCrmDialog(type) {
      this.crmDialogs[type] = true;
    },
    resetCrmForm(ref) {
      this.crmSubmitting = false;
      this.$nextTick(() => {
        if (this.$refs[ref]) {
          this.$refs[ref].resetFields();
        }

        if (this.crmServers.length === 1) {
          const forms = {
            crmRegisterForm: this.crmRegisterForm,
            crmPasswordForm: this.crmPasswordForm,
            crmTokenForm: this.crmTokenForm
          };
          forms[ref].server_uid = this.crmServers[0];
        }
      });
    },
    crmErrorMessage(error) {
      if (typeof error === "string") {
        return error;
      }

      try {
        return JSON.stringify(error);
      } catch (_error) {
        return "操作失败";
      }
    },
    requestCrmAction(url, params, successMessage, dialog, onSuccess) {
      this.crmSubmitting = true;
      this.$ajax.post(url, qs.stringify(params)).then(res => {
        this.crmSubmitting = false;

        if (res.data && res.data.error) {
          this.$message.error(this.crmErrorMessage(res.data.error));
          return;
        }

        this.$message.success(successMessage);
        this.crmDialogs[dialog] = false;

        if (onSuccess) {
          onSuccess(res.data.data);
        }
      }).catch(() => {
        this.crmSubmitting = false;
        this.$message.error("请求失败，请检查CRM节点连接");
      });
    },
    submitCrmRegister() {
      this.$refs.crmRegisterForm.validate(valid => {
        if (valid && !this.crmSubmitting) {
          this.requestCrmAction(
            "/api/crm_register_company",
            this.crmRegisterForm,
            "CRM账号注册并激活成功",
            "register",
            data => {
              if (data && data.prefix) {
                this.$alert("企业前缀：" + data.prefix, "注册结果", {
                  confirmButtonText: "确定"
                });
              }
            }
          );
        }
      });
    },
    submitCrmPassword() {
      this.$refs.crmPasswordForm.validate(valid => {
        if (valid && !this.crmSubmitting) {
          this.requestCrmAction(
            "/api/crm_reset_password",
            this.crmPasswordForm,
            "CRM密码重置成功",
            "password"
          );
        }
      });
    },
    submitCrmToken() {
      this.$refs.crmTokenForm.validate(valid => {
        if (!valid || this.crmSubmitting) {
          return;
        }

        this.$confirm("确认关闭该账号当前绑定的M令牌？", "重置M令牌", {
          confirmButtonText: "确认关闭",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.requestCrmAction(
            "/api/crm_reset_m_token",
            this.crmTokenForm,
            "M令牌已关闭",
            "token"
          );
        }).catch(() => {});
      });
    },
    // 打开添加账号弹出框
    addAccount() {
      bus.$emit("openAddAccountModel", this.allUserListData, this.allUserListData1);
    },
    // 打开修改账号弹出框
    editAccountBg(accountData,index) {
      bus.$emit("openEditAccountModel", accountData,index);
    },
    // 打开删除账号弹出框
    delAccountBg(id,account) {
      bus.$emit("openDelAccountModel", id, account);
    },
    //获取列表数据
    getUserList(accountVal, privilegesVal) {
      this.$ajax.post(
        "/api/get_user_list",
        qs.stringify({
          account: accountVal,
          privileges: privilegesVal
        }, { arrayFormat: "brackets" })
      ).then(res => {
        this.companyTotal = res.data.data.length;
        this.allUserListData = res.data.data;
        if(accountVal == "" && privilegesVal == ""){
            this.allUserListData1 = this.allUserListData;
        }else{
            this.allUserListData = res.data.data;
        }
        for(var j = 15*this.page; j< 15*(this.page+1);j++) {
          if(this.allUserListData[j]) {
            this.currentUsersListData.push(this.allUserListData[j]);
          }
        }
        this.returnChi(this.bgSearchFormDatas.bgJurisdictionVal);
      })

    },
    //搜索
    searchAccount() {
      this.currentUsersListData = [];
      this.returnEng(this.bgSearchFormDatas.bgJurisdictionVal);
      this.getUserList(this.bgSearchFormDatas.loginAccountVal, this.bgSearchFormDatas.bgJurisdictionVal);
    },
    //根据分页器页数获取当前列表数据
    getCurrentListData(page) {
      this.currentPage = page;
      this.page = page - 1;
      this.searchAccount(); 
    },
    //导出用户数据
    exportUsersData() {
      this.$ajax.post(
        "/api/export_user"
      ).then(res => {
        console.log(res);
        this.exportUrl = res.data.data;
        this.$downloadFile(res.data.data);
      })
    },
    // 转化字符-->汉字转字母
    returnEng(type) {
      for (var i = 0; i < type.length; i++) {
        var jurisdictionType = type[i];
        if (jurisdictionType == "企业订单") {
          type[i] = "company_orders"
        } else if (jurisdictionType == "企业管理") {
          type[i] = "company_manage"
        } else if (jurisdictionType == "企业观察") {
          type[i] = "company_observe"
        } else if (jurisdictionType == "企业网站") {
          type[i] = "company_website"
        } else if (jurisdictionType == "系统设置") {
          type[i] = "system_manage"
        } else if (jurisdictionType == "后台设置") {
          type[i] = "backoffice_manage"
        } else if (jurisdictionType == "企业统计") {
          type[i] = "company_stats"
        } else if (jurisdictionType == "企业趋势") {
          type[i] = "company_trend"
        }
      }
    },
    // 转化字符-->字母转汉字
    returnChi(type) {
      for(var i = 0; i < type.length;i++) {
        if (type[i] == "company_trend") {
          type[i] = "企业趋势";
        } else if (type[i] == "company_stats") {
          type[i] = "企业统计";
        } else if (type[i] == "company_orders") {
          type[i] = "企业订单";
        } else if (type[i] == "company_manage") {
          type[i] = "企业管理";
        } else if (type[i] == "company_observe") {
          type[i] = "企业观察";
        } else if (type[i] == "company_website") {
          type[i] = "企业网站";
        } else if (type[i] == "system_manage") {
          type[i] = "系统设置";
        } else if (type[i] == "backoffice_manage") {
          type[i] = "后台设置";
        }
      }
    }
  },
  filters: {
    // 转化页面名字符串
    filterPageName(value) {
      if (value == "company_trend") {
        return "企业趋势";
      } else if (value == "company_stats") {
        return "企业统计";
      } else if (value == "company_orders") {
        return "企业订单"
      } else if (value == "company_manage") {
        return "企业管理"
      } else if (value == "company_observe") {
        return "企业观察"
      } else if (value == "company_website") {
        return "企业网站"
      } else if (value == "system_manage") {
        return "系统设置"
      } else if (value == "backoffice_manage") {
        return "后台设置"
      }

    }
  },
  // 注册子组件
  components: {
    subpagination
  }
}
</script>



// WEBPACK FOOTER //
// bgSet.vue?3af4934c